<div class="maintenance-page login-banner">
  <div class="maintenance-container">
    <img class="maintenance-logo" alt="" draggable="false" [src]="'logos/nyjlogo.png' | contentAssetImage" />

    <div class="maintenance-card">
      <span class="maintenance-icon material-symbols-outlined filled" aria-hidden="true">engineering</span>

      <h2
        class="maintenance-title text-primary text-uppercase mb-0"
        [innerHTML]="'maintenancepage.title.text' | translate : { fgbdefault: 'We’ll be back soon' } | markdownTranslate"
      ></h2>

      <p
        class="maintenance-message mb-0"
        [innerHTML]="
          'maintenancepage.message'
            | translate : { fgbdefault: 'We’re currently undergoing scheduled maintenance. We should be back shortly!' }
            | markdownTranslate
        "
      ></p>
    </div>
  </div>
</div>
